import React, { useState, useEffect, useCallback, useRef } from "react";
import { getPresignedUrl } from "../../actions"; // your API helper
import ReportsFullView from "./ReportsFullView";
import VideoPlayer from "./VideoPlayer";
import Portal from "../Portal";
import "./videos.css";
import Loader from "../Loader";
import DragM from "dragm";
import defaultPoster from "../../../../assets/images/video-thumbnails/CHIEF Calendar Time Views.png";
const tutorialsVideos = [
    {
        id: "1",
        file_name: "CHIEF Calendar Time Views.mp4",
        description: "CHIEF Calendar Time Views",
        videoPath: "tutorials/CHIEF Calendar Time Views.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Calendar Time Views.png"
    },
    {
        id: "2",
        file_name: "CHIEF Dashboard Breakdown Feature.mp4",
        description: "CHIEF Dashboard Breakdown Feature",
        videoPath: "tutorials/CHIEF Dashboard Breakdown Feature.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Dashboard Breakdown Feature.png"
    },
    {
        id: "3",
        file_name: "CHIEF Dashboard Smart Links.mp4",
        description: "CHIEF Dashboard Smart Links",
        videoPath: "tutorials/CHIEF Dashboard Smart Links.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Dashboard Smart Links.png"
    },
    {
        id: "4",
        file_name: "CHIEF Entering System Test Document.mp4",
        description: "CHIEF Entering System Test Document",
        videoPath: "tutorials/CHIEF Entering System Test Document.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Entering System Test Document.png"
    },
    {
        id: "5",
        file_name: "CHIEF Entering Test Document With Failures.mp4",
        description: "CHIEF Entering Test Document With Failures",
        videoPath: "tutorials/CHIEF Entering Test Document With Failures.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Entering Test Document With Failures.png"
    },
    {
        id: "6",
        file_name: "CHIEF Fire Drill Logbook Review.mp4",
        description: "CHIEF Fire Drill Logbook Review",
        videoPath: "tutorials/CHIEF Fire Drill Logbook Review.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Fire Drill Logbook Review.png"
    },
    {
        id: "7",
        file_name: "CHIEF Generator Monthly Load Test.mp4",
        description: "CHIEF Generator Monthly Load Test",
        videoPath: "tutorials/CHIEF Generator Monthly Load Test.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Generator Monthly Load Test.png"
    },
    {
        id: "8",
        file_name: "CHIEF Icon and Color Review.mp4",
        description: "CHIEF Icon and Color Review",
        videoPath: "tutorials/CHIEF Icon and Color Review.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Icon and Color Review.png"
    },
    {
        id: "9",
        file_name: "CHIEF Inventory Training Videos.mp4",
        description: "CHIEF Inventory Training Videos",
        videoPath: "tutorials/CHIEF Inventory Training Videos.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Inventory Training Videos.png"
    },
    {
        id: "10",
        file_name: "CHIEF Weekly Event Entry.mp4",
        description: "CHIEF Weekly Event Entry",
        videoPath: "tutorials/CHIEF Weekly Event Entry.mp4",
        thumbPath: "tutorials/thumbnails/CHIEF Weekly Event Entry.png"
    }
];

export default function HelperModal({ onCancel }) {
    const [videos, setVideos] = useState([]);
    const [search, setSearch] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [selectedReport, setSelectedReport] = useState(null);
    const [showFullViewModal, setShowFullViewModal] = useState(false);

    const modalDomRef = useRef(null);

    useEffect(() => {
        modalDomRef.current = document.getElementsByClassName("pdf-mini-mod")[0] || null;
    }, []);

    useEffect(() => {
        async function loadAll() {
            try {
                const allPaths = tutorialsVideos.flatMap(v => [v.videoPath, v.thumbPath]);
                const result = await getPresignedUrl({ file_names: allPaths });
                const urls = result ?? [];
                const urlMap = urls.reduce((map, { path, url }) => {
                    map[path] = url;
                    return map;
                }, {});

                const withUrls = tutorialsVideos.map(v => ({
                    ...v,
                    url: urlMap[v.videoPath],
                    poster: defaultPoster
                }));
                setVideos(withUrls);
            } catch (err) {
                console.error("Failed to fetch presigned URLs", err);
            } finally {
                setIsLoading(false);
            }
        }

        loadAll();
    }, []);

    const handleSearch = e => setSearch(e.target.value);

    const viewSingleReport = doc => {
        setSelectedReport(doc);
        setShowFullViewModal(true);
    };

    const toggleFullViewModal = () => {
        setShowFullViewModal(prev => !prev);
    };

    const filtered = videos.filter(
        v => v.file_name.toLowerCase().includes(search.toLowerCase()) || v.description.toLowerCase().includes(search.toLowerCase())
    );

    const updateTransform = useCallback(transformStr => {
        if (modalDomRef.current) {
            modalDomRef.current.style.transform = transformStr;
        }
    }, []);

    return (
        <>
            {showFullViewModal && (
                <Portal body={<ReportsFullView selectedReport={selectedReport} onCancel={toggleFullViewModal} />} onCancel={toggleFullViewModal} />
            )}

            <div className="modal slt-img-modl pdf-mini-mod narr" style={{ display: "block" }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <DragM updateTransform={updateTransform}>
                            <div className="modal-header draggable">
                                <div className="d-flex col-md-12 pl-0 align-items-center video-dshb-head">
                                    <div className="col-md-8 pl-0">
                                        <h5 className="modal-title">Training Videos</h5>
                                    </div>
                                    <div className="col-md-4 search-sec-wrap">
                                        <form className="condition-search-outer">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search Here"
                                                value={search}
                                                onChange={handleSearch}
                                            />
                                        </form>
                                    </div>
                                </div>
                                <button type="button" className="close not-draggable" aria-label="Close" onClick={onCancel}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </DragM>

                        <div className="modal-body region-otr build-type-mod pdf-mini-modal">
                            {isLoading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                                    <Loader />
                                </div>
                            ) : (
                                <div className="pdf-miniature-otr">
                                    {filtered.length > 0 ? (
                                        filtered.map(doc => (
                                            <VideoPlayer
                                                key={doc.id}
                                                url={doc.url}
                                                poster={doc.poster}
                                                description={doc.description}
                                                onClick={() => viewSingleReport(doc)}
                                            />
                                        ))
                                    ) : (
                                        <div className="coming-soon no-data">
                                            <div className="coming-txt">
                                                <h3>No Videos Found!</h3>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
